<template>
<main>
  <Content>
    <h1>coming soon ¯\_(ツ)_/¯</h1>
    <p>
      The cityphography project is more than just the letters, it is also a collection of some pretty cool street photography. 
      <br/>      
      <br/>      
      Here you can soon browse some of the best photos in a neat online gallery, and more will be added along the way. 
      <br/>
      <br/>
      And if you fall in love with any of them, you'll be able to order them to your door, in the best possible quality, printed in an Epson Digigraphie certified fine art print manufacture.
      <br/>
      <br/>
      Until then, take a look and follow our <a href="https://www.instagram.com/cityphography" target="_blank">Instagram</a> to see what's coming, and don't hesitate telling your friends about this project ;)
    </p>
  </Content>
</main>
</template>

<script>

import Content from '@/components/Content.vue';

export default {
  name: 'Prints' ,
  components: {
    Content
  },
  metaInfo: {
      title: "prints - cityphography",
      meta: [        
        { vmid: "og:title", property: "og:title", content: "prints - cityphography" },
        { vmid: "description", name: "description", content: "Available prints coming soon! Check out our Instagram meanwhile." },
        { vmid: "og:description", property: "og:description", content: "Available prints coming soon! Check out our Instagram meanwhile." }                                
      ],    
  }  
}
</script>